import { HTML_INPUT_DATE_FORMAT } from '@/mixins/js_config'

var FilterMixin = {
  methods: {
    param2DataRange: function(params, key) {
      var beginKey = key + '[begin]'
      var endKey = key + '[end]'

      if (params[beginKey] && params[endKey]) {
        var beginDate = moment(params[beginKey]).startOf('day')
        var endDate = moment(params[endKey]).endOf('day')
        return [beginDate, endDate]
      }

      return null
    },

    /******************************** 将 API 参数转化为组件需要的数据类型 ********************************/
    /**
     * 将参数转化为组件需要的范围值
     *
     * @param {string} rangeParamStr 范围参数，如：1~10
     * @returns {Array} length 为 2 的数组
     */
    parseApiParam2Range(rangeParamStr) {
      if (rangeParamStr === null || rangeParamStr === undefined) return ['', '']
      return rangeParamStr.split('~')
    },
    /**
     * 将参数转化为数组
     *
     * @param {string} arrayParam 使用逗号分隔的数组参数
     * @returns {Array} 返回的数组
     */
    parseApiParam2Array(arrayParam) {
      if (arrayParam === null || arrayParam === undefined) return []
      return arrayParam.split(',')
    },

    /**
     * 将日期范围参数转化为 picker使用的值
     *
     * @param {string} dateRangeParam API的日期范围参数
     * @returns {?Array<Date>} model 日期范围选择组件的数据模型
     */
    parseApiParam2DateRangePicker(dateRangeParam) {
      if (dateRangeParam === undefined) return null

      let dataRange = dateRangeParam.split('~')
      return [new Date(dataRange[0]), new Date(dataRange[1])]
    },

    /******************************** 将 组件的数据 转化为 API参数 ********************************/

    /**
     * 将数组转化为参数
     * 一般使用“~”分隔的字符串
     *
     * @param {Array} range 范围参数
     * @returns {string} 范围的API参数表达
     */
    parseRange2ApiParam(range) {
      let value = range.join('~')
      return value === '~' ? null : value
    },
    /**
     * 将数组转化为参数
     * 一般使用逗号分隔的字符串
     *
     * @param {Array} array 数组
     * @returns {string} 数组的API参数表达
     */
    parseArray2ApiParam(array) {
      let value = array.join(',')
      return value === '' ? null : value
    },
    /**
     * 日期范围选择转化为API参数
     *
     * @param {?Array<Date>} model 日期范围选择组件的数据模型
     * @returns {string} API的日期范围参数
     */
    dateRangePicker2ApiParam(model) {
      if (model === null) {
        return null
      }

      let beginDateTime = model[0]
      let endDateTime = model[1]
      let beginDateStr = moment(beginDateTime).format('YYYY-MM-DD')
      let endDateStr = moment(endDateTime).format('YYYY-MM-DD')

      return `${beginDateStr}~${endDateStr}`
    },

    // search-panel 时间范围控件返回正确参数, [Moment, Moment] => "2019-01-20|2019-01-21"
    parseDateRange2Param(range) {
      if (range !== null && range !== undefined && range !== '') {
        let value = range.map(function(item) {
          if (item !== '') {
            item = item.format(HTML_INPUT_DATE_FORMAT)
            return item
          }
        })
        value = value.join('|')
        return value === '|' ? null : value
      }
    },

    // search-panel 返回 “2019-02-16~2019-02-22”
    parseParam2DateRange(rangeParam) {
      if (rangeParam === null || rangeParam === undefined || rangeParam[0] == '' || rangeParam[1] == '') {
        return ''
      } else {
        return rangeParam[0].format(HTML_INPUT_DATE_FORMAT) + '~' + rangeParam[1].format(HTML_INPUT_DATE_FORMAT)
      }
    },

    // 将参数 1|2 转化为 range [1, 2]
    parseParam2Range(rangeParam) {
      if (rangeParam === null || rangeParam === undefined) return ['', '']
      return rangeParam.split('|')
    },
    parseParam2TimeRange(rangeParam) {
      if (rangeParam === null || rangeParam === undefined) return [null, null]
      let timerange = rangeParam.split('|')
      return [moment(timerange[0]), moment(timerange[1])]
    },
    rangeDisplay(range, suffix) {
      let begin = range[0]
      let end = range[1]

      if (begin === '') {
        return '≤ ' + end + ' ' + suffix
      }
      if (end == '') {
        return '≥ ' + begin + ' ' + suffix
      }

      return begin + ' ~ ' + end + ' ' + suffix
    },
    /**
     * 是否有选中的筛选
     *
     * @param {object} filter  当前选中的筛选
     * @param {object} supportedFilterFields 支持的筛选字段
     * @returns {boolean} 是否有筛选
     */
    hasFilter(filter, supportedFilterFields = {}) {
      for (let prop in filter) {
        let filterItem = filter[prop]
        let filterItemSearchDefined = supportedFilterFields[prop]
        if (filterItem !== null && filterItemSearchDefined) {
          return true
        }
      }
      return false
    }
  }
}

export { FilterMixin as default }
